export enum PsLibraryFilterEnum {
  Class = 'Class',
  Topic = 'Topic',
  Subject = 'Subject',
  Author = 'Author',
  Theme = 'Theme',
  Level = 'Level',
}
